<template>
  <layout-modal-component
    v-if="participant"
    :key="data?.slug"
    :class="$style.root"
    :close-path="closePath"
  >
    <template #header>
      <div :class="$style.header">
        <div
          :class="$style.label"
        >
          {{$t('labels.participant', { count: 1 })}}
        </div>
        <h1
          v-if="participant?.title"
          :class="$style.title"
        >
          {{ participant?.title }}
        </h1>

        <h2
          v-if="participant?.subtitle"
          :class="$style.subtitle"
        >
          {{ participant?.subtitle }}
        </h2>

        <div v-if="participant?.annotation">
          {{ participant?.annotation }}
        </div>
      </div>
    </template>

    <core-media-carousel-component
      v-if="data?.images?.length"
      :key="data?.slug"
      :class="$style.carousel"
      :images="data?.images"
      :videos="data?.muxAssets?.filter(i => i?.isReady === true)"
    />

    <core-text-component
      v-if="data?.richText"
      :key="data?.richText"
      :class="$style.richText"
      :string="data.richText"
    />
  </layout-modal-component>
</template>

<script lang="ts" setup>
const route = useRoute()

const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryBiennialParticipantById(getPageQuery({id: route.query.participantId})) } } ) )

data.value = getFirstObject(data.value.data)

const participant = computed(() => formatParticipantHeadingObject(data.value))
const closePath = computed(() => getClosePath('editions-slug-index-participants', { slug: route.params.slug },  { view: route?.query?.view } ))
</script>

<style module>
.header {
}

.label {
  color: var(--color--secondary);
}

.title {
  composes: reset-heading font-size-large from global;
}

.subtitle {
  composes: reset-heading font-size-default from global;
}

.carousel + .richText {
  margin-top: var(--font-default--line-height);
}

.richText {
  composes: font-size-default from global;
}
</style>
